import { useEffect, useState } from "react";
import { CongestionsService } from "../utility";

export const GetMultipleCongestionData = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    zoom: 8,
    bbox: [],
    keys: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await CongestionsService.getMultipleLayers(filter);
        setData(response);
      } catch (error) {
        console.log(error);
      }
    };
    if (filter.keys.length) {
      fetchData();
    }
  }, [filter]);

  const filterChanged = (newfilter) => {
    setFilter({ ...filter, ...newfilter });
  };

  return { data, filterChanged };
};
